// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFoundPage_wrapper__1yvv-"};